import agra from './assets/weekend/Agra.webp'
import florida from './assets/weekend/florida.webp'
import india from './assets/weekend/India.webp'
import italy from './assets/weekend/italy.webp'
import magic from './assets/weekend/Magic.webp'
import maxico from './assets/weekend/Maxico.webp'
import maxicoCity from './assets/weekend/MaxicoCity.webp'
import NewYork from './assets/weekend/NewYork.webp'
import peru from './assets/weekend/Peru.webp'
import poland from './assets/weekend/poland.webp'
import usa from './assets/weekend/usa.webp'

const data = [{
        background: `${agra}`,
        rating: '4.9 (145)',
        city: 'India',
        caption: 'Virtual tour of Taj Mahal',
        rent: 'From ₹300/'
    },{
        background: `${florida}`,
        rating: '4.33 (50)',
        city: 'United States',
        caption: 'Drink and Draw, blind contour art fun',
        rent: 'From ₹1,565/'
    },{
        background: `${india}`,
        rating: '5.0 (45)',
        city: 'India',
        caption: 'Refreshing yourself with chai or other spicy indian drinks',
        rent: 'From ₹700/'
    },{
        background: `${italy}`,
        rating: '5.0 (59)',
        city: 'Italy',
        caption: 'Italian party with spritz',
        rent: 'From ₹2,607/'
    },{
        background: `${magic}`,
        rating: '4.5 (34)',
        city: 'United Kingdom',
        caption: 'Thrilling Murder Mystery and Magic Show',
        rent: 'From ₹2,069/'
    },{
        background: `${maxicoCity}`,
        rating: '4.33 (64)',
        city: 'South Africa',
        caption: 'Plan perfect trip to sunny Miami',
        rent: 'From ₹1,718/'
    },{
        background: `${maxico}`,
        rating: '3.33 (47)',
        city: 'Maxico',
        caption: 'W0rlds Top Cofee Masterclass ',
        rent: 'From ₹899/'
    },{
        background: `${peru}`,
        rating: '4.33 (39)',
        city: 'Peru',
        caption: 'Vedic Astrology Reading',
        rent: 'From ₹5,105/'
    },{
        background: `${NewYork}`,
        rating: '4.33 (51)',
        city: 'United States',
        caption: 'How to Read Future With Cofee',
        rent: 'From ₹3,565/'
    },{
        background: `${poland}`,
        rating: '4.5 (72)',
        city: 'Poland',
        caption: 'Murder Mystery Escape game',
        rent: 'From ₹1,465/'
    },{
        background: `${usa}`,
        rating: '4.2 (34)',
        city: 'United States',
        caption: 'Healing Energy Meditation with Coach',
        rent: 'From ₹565/'
    }]
    export default data;